import { Box } from "@mui/material";
import { Recipe, recipeUrl } from "../data";
import RecipeCard from "./RecipeCard";

export interface RecipesGridProps {
    recipes: Recipe[];
}

export default function RecipesGrid({ recipes }: RecipesGridProps) {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, 200px)",
                justifyItems: "center",
                rowGap: "30px",
                columnGap: "30px",
                justifyContent: "center",
            }}
        >
            {recipes.map(recipe => (
                <RecipeCard key={recipe.id} recipe={recipe} link={recipeUrl(recipe)}></RecipeCard>
            ))}
        </Box>
    );
}
